module.exports = __webpack_public_path__ + "img/date-range.0f6c494b.svg";